// 1. IMPORTS
import PaymentMethodServiceAPI from "./PaymentMethodServiceAPI";

// 4. BACKWARD-COMPATIBLE SERVICE METHODS
class PaymentMethodService {
  static getAdvanceUserList(data) {
    return PaymentMethodServiceAPI.getListPaymentMethod(data);
  }

  static advanceUserUpdateById(data) {
    return PaymentMethodServiceAPI.updatePaymentMethod(data);
  }
}

// 9. EXPORTS
export default PaymentMethodService;